import { AbstractSearchCriteria } from './abstract-search-criteria';

export class MappedResourceTypeSearchCriteria extends AbstractSearchCriteria {
    mappedCode: string;
    mappedName: string;
    resourceTypeCode: string;
}
